import * as React from 'react';
import { MdClear } from 'react-icons/md';
import { useTheme } from '../Theme/Theme';
import { chipIconCss, style } from './style';
export const Tag = (props) => {
    const theme = useTheme();
    const tagCss = style({ props, theme });
    return (React.createElement("span", { className: tagCss, onClick: (e) => props === null || props === void 0 ? void 0 : props.onClick(e), style: props.style },
        props.children,
        props.chips && (React.createElement("span", { className: chipIconCss },
            React.createElement(MdClear, null)))));
};
Tag.defaultProps = {
    style: {},
    size: 'DEFAULT',
};
//# sourceMappingURL=Tag.js.map